import axios from 'axios';


import { invalidateReclamationIndicateurEmises } from '../reclamation/indicateursActions';
import { invalidateReclamationIndicateurAffectees } from '../reclamation/indicateursActions';
import { invalidateReclamationIndicateurObservateur } from '../reclamation/indicateursActions';
import { invalidateReclamationIndicateurCommentaires } from '../reclamation/indicateursActions';
import { invalidateReclamationIndicateurCreees } from '../reclamation/indicateursActions';
import { invalidateReclamationIndicateurCloturees } from '../reclamation/indicateursActions';


import { invalidateTypeIndicateurs } from '../type/indicateursActions';

import { invalidateUtilisateurIndicateurs } from '../utilisateur/indicateursActions';


/**
   * Liste des actions
 */
export const Actions = {
       
    FETCH_SOUFFRANCES_TRANSPORTEUR_REQUEST: 'FETCH_SOUFFRANCES_TRANSPORTEUR_REQUEST',
    FETCH_SOUFFRANCES_TRANSPORTEUR_SUCCESS: 'FETCH_SOUFFRANCES_TRANSPORTEUR_SUCCESS',
    FETCH_SOUFFRANCES_TRANSPORTEUR_FAILURE: 'FETCH_SOUFFRANCES_TRANSPORTEUR_FAILURE',
    
    CLEAR_SOUFFRANCES_TRANSPORTEUR: 'CLEAR_SOUFFRANCES_TRANSPORTEUR',

    IMPORT_SOUFFRANCES_TRANSPORTEUR_REQUEST: 'IMPORT_SOUFFRANCES_TRANSPORTEUR_REQUEST',
    IMPORT_SOUFFRANCES_TRANSPORTEUR_SUCCESS: 'IMPORT_SOUFFRANCES_TRANSPORTEUR_SUCCESS',
    IMPORT_SOUFFRANCES_TRANSPORTEUR_FAILURE: 'IMPORT_SOUFFRANCES_TRANSPORTEUR_FAILURE'
};


/**
 * ActionCreator pour récupérer les informations des souffrances
 */
const fetchSouffrancesTransporteurRequest = (fichierId) => ({ type: Actions.FETCH_SOUFFRANCES_TRANSPORTEUR_REQUEST, fichierId });
const fetchSouffrancesTransporteurSuccess = (souffrancesTransporteur) => ({ type: Actions.FETCH_SOUFFRANCES_TRANSPORTEUR_SUCCESS, souffrancesTransporteur });
const fetchSouffrancesTransporteurFailure = (error) => ({ type: Actions.FETCH_SOUFFRANCES_TRANSPORTEUR_FAILURE, error });

export const fetchSouffrancesTransporteur = (fichierId) => async (dispatch, getState) => {
    if (!getState().souffrancesTransporteur.isLoading) {
        
        dispatch(fetchSouffrancesTransporteurRequest(fichierId));

        try {
            let response = await axios.get(`api/souffrances-transporteur?fichierId=${fichierId}`);
            dispatch(fetchSouffrancesTransporteurSuccess(response.data));

        } catch (error) {
            console.error('fetchSouffrancesTransporteur : ', error);
            dispatch(fetchSouffrancesTransporteurFailure(error));
        }
    }
};


/**
 * ActionCreator pour CLEAR_SOUFFRANCES_TRANSPORTEUR
 */
export const clearSouffrancesTransporteur = () => ({ type: Actions.CLEAR_SOUFFRANCES_TRANSPORTEUR });




/**
 * ActionCreator pour récupérer l'import des souffrances
 */
const importSouffrancesTransporteurRequest = () => ({ type: Actions.IMPORT_SOUFFRANCES_TRANSPORTEUR_REQUEST });
const importSouffrancesTransporteurSuccess = (importResult) => ({ type: Actions.IMPORT_SOUFFRANCES_TRANSPORTEUR_SUCCESS, importResult });
const importSouffrancesTransporteurFailure = (error) => ({ type: Actions.IMPORT_SOUFFRANCES_TRANSPORTEUR_FAILURE, error });

export const importSouffrancesTransporteur = (souffrancesTransporteur) => async (dispatch, getState) => {
    if (!getState().souffrancesTransporteur.isAdding) {

        dispatch(importSouffrancesTransporteurRequest());

        let param = {
            souffrancesTransporteur: souffrancesTransporteur
        };

        try {
            let response = await axios.post(`api/souffrances-transporteur`, param);

            dispatch(importSouffrancesTransporteurSuccess(response.data));
            
            dispatch(invalidateReclamationIndicateurEmises());
            dispatch(invalidateReclamationIndicateurAffectees());
            dispatch(invalidateReclamationIndicateurObservateur());
            dispatch(invalidateReclamationIndicateurCommentaires());
            dispatch(invalidateReclamationIndicateurCreees());
            dispatch(invalidateReclamationIndicateurCloturees());

            dispatch(invalidateTypeIndicateurs());

            dispatch(invalidateUtilisateurIndicateurs());
                        

        } catch (error) {
            console.error('importSouffrancesTransporteur : ', error);
            dispatch(importSouffrancesTransporteurFailure(error));
        }
    }
};




